/* NEWLUNA 3D collection ring (3.0).
   Every product floats on a slowly rotating ring. Drag or swipe to spin,
   tap a side product to bring it forward, tap the front product to open it.

   Rendering notes (fixes for the flicker seen while rotating):
   - Only transform and opacity change per frame. No filters, no blend modes,
     no box reflections on moving elements.
   - Stacking order is derived from each card's exact depth rank and only
     written when it changes, so cards never swap places mid-move.
   - The front card is drawn at scale 1, never above, so text stays sharp.
   Without JavaScript the list stays a simple horizontal scroll row. */
(function () {
  'use strict';
  var html = document.documentElement;

  function init(root) {
    var stage = root.querySelector('[data-c3d-stage]');
    var items = Array.prototype.slice.call(root.querySelectorAll('[data-c3d-item]'));
    var chips = Array.prototype.slice.call(root.querySelectorAll('[data-c3d-go]'));
    var n = items.length;
    if (!stage || n < 3) return;

    var reduce = html.classList.contains('reduce-motion') || window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var auto = root.getAttribute('data-auto') !== 'false' && !reduce;
    var TAU = Math.PI * 2;
    var step = TAU / n;
    var rot = 0, target = null, vel = 0;
    var R = 400, tilt = 60, front = -1;
    var dragging = false, captured = false, moved = 0, lastX = 0, lastT = 0, pid = null;
    var paused = false, idleUntil = 0, visible = true, raf = 0, prev = 0;

    var veils = items.map(function (el) { return el.querySelector('.c3d__veil'); });
    var links = items.map(function (el) { return el.querySelector('a'); });
    var cache = items.map(function () { return { z: -1, o: -1, t: '' }; });
    var order = items.map(function (_, i) { return i; });
    var depth = new Array(n);

    root.classList.add('is-3d');

    function measure() {
      var w = stage.clientWidth || window.innerWidth;
      R = Math.min(560, w * (w < 750 ? 0.6 : 0.4));
      tilt = w < 750 ? 54 : Math.min(120, w * 0.08);
    }

    function layout() {
      var i, a, sin, cos, d, best = -1, bi = 0;
      for (i = 0; i < n; i++) {
        a = rot + i * step;
        sin = Math.sin(a); cos = Math.cos(a);
        d = (cos + 1) / 2; /* 0 = far back, 1 = front */
        depth[i] = d;
        var x = sin * R, y = cos * tilt, s = 0.58 + d * 0.42;
        var t = 'translate3d(' + x.toFixed(1) + 'px,' + y.toFixed(1) + 'px,0) scale(' + s.toFixed(4) + ') rotateY(' + (sin * 20).toFixed(2) + 'deg)';
        var c = cache[i];
        if (t !== c.t) { items[i].style.transform = t; c.t = t; }
        var o = Math.round((1 - d) * 55) / 100;
        if (o !== c.o && veils[i]) { veils[i].style.opacity = String(o); c.o = o; }
        if (d > best) { best = d; bi = i; }
      }
      /* stable depth ranking: index breaks exact ties */
      order.sort(function (p, q) { return (depth[p] - depth[q]) || (p - q); });
      for (i = 0; i < n; i++) {
        var idx = order[i];
        if (cache[idx].z !== i + 1) { items[idx].style.zIndex = String(i + 1); cache[idx].z = i + 1; }
      }
      if (bi !== front) {
        front = bi;
        items.forEach(function (el, j) {
          el.classList.toggle('is-front', j === front);
          if (links[j]) links[j].setAttribute('tabindex', j === front ? '0' : '-1');
        });
        chips.forEach(function (c, j) { c.setAttribute('aria-current', j === front ? 'true' : 'false'); });
      }
    }

    function angleFor(i) {
      var t = -i * step, k = Math.round((rot - t) / TAU);
      return t + k * TAU;
    }
    function nearest() {
      var i = Math.round(-rot / step);
      return ((i % n) + n) % n;
    }
    function goTo(i) {
      i = ((i % n) + n) % n;
      target = angleFor(i);
      vel = 0;
      idleUntil = performance.now() + 7000;
      if (reduce) { rot = target; target = null; layout(); return; }
      kick();
    }

    function frame(now) {
      raf = 0;
      var dt = prev ? Math.min(40, Math.max(0, now - prev)) : 16;
      prev = now;
      if (!dragging) {
        if (target !== null) {
          rot += (target - rot) * Math.min(1, dt * 0.0085);
          if (Math.abs(target - rot) < 0.0005) { rot = target; target = null; }
        } else if (vel !== 0) {
          rot += vel * dt;
          vel *= Math.pow(0.93, dt / 16);
          if (Math.abs(vel) < 0.00005) { vel = 0; target = angleFor(nearest()); }
        } else if (auto && !paused && now > idleUntil) {
          rot -= 0.0001 * dt;
        }
      }
      layout();
      if (visible && !document.hidden && (dragging || target !== null || vel !== 0 || (auto && !paused))) kick();
      else prev = 0; /* loop pauses; the next start begins with a fresh frame time */
    }
    function kick() { if (!raf) raf = requestAnimationFrame(frame); }

    /* Drag and swipe */
    stage.addEventListener('pointerdown', function (e) {
      if (e.button !== undefined && e.button !== 0) return;
      dragging = true; captured = false; moved = 0; vel = 0; target = null;
      lastX = e.clientX; lastT = performance.now(); pid = e.pointerId;
      kick();
    });
    stage.addEventListener('pointermove', function (e) {
      if (!dragging || e.pointerId !== pid) return;
      var dx = e.clientX - lastX, now = performance.now();
      lastX = e.clientX; moved += Math.abs(dx);
      if (!captured && moved > 6) {
        captured = true; stage.classList.add('is-dragging');
        try { stage.setPointerCapture(pid); } catch (err) { /* ignore */ }
      }
      var dr = dx / (R * 1.6);
      rot += dr;
      vel = dr / Math.max(8, now - lastT);
      lastT = now;
    });
    function end(e) {
      if (!dragging || (e && e.pointerId !== pid)) return;
      dragging = false; stage.classList.remove('is-dragging');
      if (performance.now() - lastT > 80) vel = 0;
      if (!vel) target = angleFor(nearest());
      idleUntil = performance.now() + 7000;
      kick();
    }
    stage.addEventListener('pointerup', end);
    stage.addEventListener('pointercancel', end);
    stage.addEventListener('lostpointercapture', end);

    /* Clicks: a drag never opens a product; a side product comes forward first */
    stage.addEventListener('click', function (e) {
      var item = e.target.closest('[data-c3d-item]');
      if (moved > 6) { e.preventDefault(); e.stopPropagation(); moved = 0; return; }
      if (item && !item.classList.contains('is-front')) {
        e.preventDefault();
        goTo(items.indexOf(item));
      }
    }, true);

    var prevBtn = root.querySelector('[data-c3d-prev]'), nextBtn = root.querySelector('[data-c3d-next]');
    if (prevBtn) prevBtn.addEventListener('click', function () { goTo(front - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goTo(front + 1); });
    chips.forEach(function (c) {
      c.addEventListener('click', function () { goTo(parseInt(c.getAttribute('data-c3d-go'), 10) || 0); });
    });
    stage.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); goTo(front + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(front - 1); }
    });
    function setPaused(p) { paused = p; if (!p) kick(); }
    stage.addEventListener('mouseenter', function () { setPaused(true); });
    stage.addEventListener('mouseleave', function () { setPaused(false); });
    root.addEventListener('focusin', function () { setPaused(true); });
    root.addEventListener('focusout', function (e) { if (!root.contains(e.relatedTarget)) setPaused(false); });
    document.addEventListener('visibilitychange', function () { if (!document.hidden) kick(); });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        visible = entries[0].isIntersecting;
        if (visible) kick();
      }, { rootMargin: '120px' }).observe(stage);
    }
    var rt;
    window.addEventListener('resize', function () {
      clearTimeout(rt);
      rt = setTimeout(function () { measure(); cache.forEach(function (c) { c.t = ''; }); layout(); }, 80);
    }, { passive: true });

    measure();
    layout();
    kick();
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-c3d]'), function (root) {
      if (!root.classList.contains('is-3d')) init(root);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
